import { useEffect, useState } from "react";
import { Area, AreaChart, Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { PageTitle, Stat } from "@/components/app/ui";
import { api } from "@/lib/api";
import { TrackingStats } from "@/pages/app/Leads";

export default function Analytics() {
  const [d, setD] = useState(null);
  const [t, setT] = useState(null);
  useEffect(() => { api.get("/app/analytics").then((r) => setD(r.data)); api.get("/app/tracking").then((r) => setT(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="h-64 rounded-2xl bg-muted animate-pulse" />;
  const last = d.weeks[d.weeks.length - 1];
  return (
    <div data-testid="analytics-page">
      <PageTitle title="Analytics" copy="Performance from connected channels appears here.">
        <span className="rounded-full bg-[#f59e0b]/15 px-3 py-1.5 font-mono text-[10px] uppercase text-[#b45309] dark:text-[#fbbf24]" data-testid="analytics-illustrative-badge">Illustrative data</span>
      </PageTitle>
      {t && <div className="mb-8" data-testid="analytics-tracking"><div className="eyebrow mb-3">Measured by Sliance · real tracked data</div><TrackingStats t={t} /></div>}
      <div className="eyebrow mb-3">Channel reach · illustrative until live analytics are connected</div>
      <div className="grid gap-4 sm:grid-cols-3">
        <Stat label="Reach this week" value={last.reach.toLocaleString()} color="#7c3aed" testId="analytics-reach" />
        <Stat label="Engagements" value={last.engagement.toLocaleString()} color="#db2777" testId="analytics-engagement" />
        <Stat label="Clicks" value={last.clicks.toLocaleString()} color="#06b6d4" testId="analytics-clicks" />
      </div>
      <div className="mt-6 card-box p-6" data-testid="analytics-summary">
        <div className="eyebrow">Weekly summary</div>
        <p className="mt-3 text-base leading-relaxed">{d.summary}</p>
      </div>
      <div className="mt-6 grid lg:grid-cols-12 gap-6">
        <div className="lg:col-span-8 card-box p-6 h-80">
          <h3 className="font-semibold mb-4">Reach & engagement (8 weeks)</h3>
          <ResponsiveContainer width="100%" height="85%">
            <AreaChart data={d.weeks}>
              <defs><linearGradient id="ar" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#4f46e5" stopOpacity={0.45} /><stop offset="100%" stopColor="#4f46e5" stopOpacity={0} /></linearGradient></defs>
              <CartesianGrid strokeDasharray="3 3" opacity={0.15} /><XAxis dataKey="week" fontSize={12} /><YAxis fontSize={12} /><Tooltip />
              <Area dataKey="reach" stroke="#4f46e5" fill="url(#ar)" strokeWidth={2} /><Area dataKey="engagement" stroke="#db2777" fill="transparent" strokeWidth={2} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
        <div className="lg:col-span-4 card-box p-6 h-80">
          <h3 className="font-semibold mb-4">Channel mix (%)</h3>
          <ResponsiveContainer width="100%" height="85%">
            <BarChart data={d.channels}><XAxis dataKey="channel" fontSize={11} /><YAxis fontSize={11} /><Tooltip /><Bar dataKey="value" fill="#10b981" radius={[6, 6, 0, 0]} /></BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
